import React from 'react'
import { Field } from 'formik'
import { Columns, Heading } from 'react-bulma-components'
import InputField from '../../form/fields/input'
import SelectField from '../../form/fields/select'
import { BoundsConfigSectionProps } from './types'

/**
 * Component that handles bounds configuration (min or max)
 * Manages fixed vs dynamic modes and conditional fields
 */
const BoundsConfigSection: React.FC<BoundsConfigSectionProps> = ({ boundsType, values }) => {
  const isMin = boundsType === 'min'
  const boundsMode = isMin ? values.minBoundsMode : values.maxBoundsMode
  const modeFieldName = isMin ? 'interval.minBoundsMode' : 'interval.maxBoundsMode'
  const valueFieldName = isMin ? 'interval.min' : 'interval.max'
  const pathFieldName = isMin ? 'interval.minPath' : 'interval.maxPath'
  const fallbackFieldName = isMin ? 'interval.minFallback' : 'interval.maxFallback'
  const label = isMin ? 'Valeur minimale' : 'Valeur maximale'
  const valueLabel = isMin
    ? 'Règle appliquée à partir de (minutes)'
    : "Règle appliquée jusqu'à (minutes)"
  const pathLabel = isMin ? 'Chemin pour la valeur minimale' : 'Chemin pour la valeur maximale'
  const fallbackLabel = isMin
    ? 'Valeur de fallback pour min (minutes)'
    : 'Valeur de fallback pour max (minutes)'
  const pathHelp = 'Chemin vers une valeur dans les données de résumé'
  const fallbackHelp = "Valeur utilisée si le chemin retourne 0 ou n'existe pas"

  return (
    <Columns>
      <Columns.Column size={12}>
        <Heading size={6}>{label}</Heading>
      </Columns.Column>
      <Columns.Column size={6}>
        <Field
          label="Mode de définition"
          name={modeFieldName}
          component={SelectField}
          options={[
            { value: 'fixed', label: 'Valeur fixe' },
            { value: 'dynamic', label: 'Valeur dynamique' },
          ]}
          required
          fullwidth
        />
      </Columns.Column>
      <Columns.Column size={6}>
        {boundsMode === 'fixed' ? (
          <Field
            label={valueLabel}
            name={valueFieldName}
            component={InputField}
            type="number"
            required={isMin}
          />
        ) : (
          <Field
            label={pathLabel}
            name={pathFieldName}
            component={SelectField}
            options={[
              { value: 'durations.contract.total', label: 'Durée totale du contrat' },
              {
                value: 'durations.contract.remainingAfterBenefit',
                label: 'Durée restante du contrat après évènements prestations',
              },
            ]}
            required
            help={pathHelp}
          />
        )}
      </Columns.Column>
      {boundsMode === 'dynamic' && (
        <Columns.Column size={6}>
          <Field
            label={fallbackLabel}
            name={fallbackFieldName}
            component={InputField}
            type="number"
            help={fallbackHelp}
          />
        </Columns.Column>
      )}
    </Columns>
  )
}

export default BoundsConfigSection
